import React from "react"
import { Link, graphql } from "gatsby"

import Img from "gatsby-image"
import Layout from "../../components/layout"
import BackgroundImage from 'gatsby-background-image'
import SEO from "../../components/seo"
import Header from "./../../components/header"
import ListItem from "./../../components/ListItem"
import CardItem from "./../../components/CardItem"
import BadgeItem from "./../../components/BadgeItem"
import IconItem from "./../../components/IconItem"
import SpecialItem from "./../../components/SpecialItem"
import { GiRollingDices } from 'react-icons/gi';

export default function Estacades({ data }) {
  return (
    <Layout>
      <Header title="Retour" href="/" />
      <SEO title="Les estacades" />

      <div className="banner no-bg">
        <h1>Les estacades</h1>
      </div>

      <SpecialItem
        to="/estacades/jeux"
        title="Jeux"
        subtitle="Découvrir le monde maritime et les bateaux du musée en s'amusant"
        icon={GiRollingDices}
      />

      <h2 className="intertitre">Les bateaux</h2>

      <BadgeItem
        to="/estacades/an-eostig"
        title="An Eostig"
        subtitle="Chaloupe sardinière"
        img={data.aneostig}
      />
      <BadgeItem
        to="/estacades/anna-rosa"
        title="Anna-Rosa"
        subtitle="Galéasse norvégienne"
        img={data.annarosa}
      />
      <BadgeItem
        to="/estacades/dieu-protege"
        title="Dieu Protège"
        subtitle="Gabare de l'Iroise"
        img={data.dieuprotege}
      />
      <BadgeItem
        to="/estacades/nizwa"
        title="Nizwa"
        subtitle="Boutre arabe"
        img={data.nizwa}
      />
      <BadgeItem
        to="/estacades/roi-gradlon"
        title="Roi Gradlon"
        subtitle="Baliseur"
        img={data.roigradlon}
      />
      <BadgeItem
        to="/estacades/saint-denys"
        title="Saint Denys"
        subtitle="Remorqueur portuaire"
        img={data.saintdenys}
      />
      <BadgeItem
        to="/estacades/scarweather"
        title="Scarweather"
        subtitle="Bateau-phare"
        img={data.scarweather}
      />


    </Layout>
  )
}

export const query = graphql`
  query {
    annarosa: file(relativePath: { eq: "estacades/anna-rosa/anna-rosa.jpg" }) {
      ...CardImage
      ...BadgeImage
    }
    roigradlon: file(relativePath: { eq: "estacades/roi-gradlon/a.jpg" }) {
      ...CardImage
      ...BadgeImage
    }
    dieuprotege: file(relativePath: { eq: "estacades/dieu-protege/dieu-protege.jpg" }) {
      ...CardImage
      ...BadgeImage
    }
    saintdenys: file(relativePath: { eq: "estacades/saint-denys/saint-denys.jpg" }) {
      ...CardImage
      ...BadgeImage
    }
    nizwa: file(relativePath: { eq: "estacades/nizwa/nizwa.jpg" }) {
      ...CardImage
      ...BadgeImage
    }
    aneostig: file(relativePath: { eq: "estacades/an-eostig/an-eostig.jpg" }) {
      ...CardImage
      ...BadgeImage
    }
    scarweather: file(relativePath: { eq: "estacades/scarweather/scarweather.jpg" }) {
      ...CardImage
      ...BadgeImage
    }
    bg: file(relativePath: { eq: "estacades/estacades.jpeg" }) {
      childImageSharp {
        fluid(maxWidth: 360) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
